import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorPage from "./Components/Pages/404Page";
import LandingPage from "./Components/Pages/LandingPage";
import { SmoothScrollProvider } from './context/SmoothScrollContext';
import { initializeCookies } from './config/cookies';
import {useEffect} from "react";

function App() {
    useEffect(() => {
        initializeCookies();
    }, []);
    return (
        <BrowserRouter>
            <SmoothScrollProvider>
                <div className="font-gilroy font-medium text-gray text-lg leading-[27px]">
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="*" element={<ErrorPage />} />
                    </Routes>
                </div>
            </SmoothScrollProvider>
        </BrowserRouter>
    );
}

export default App;